import React from 'react';

export default class UserFb extends React.Component {

	constructor(props) {
		super(props);
		this.onCloseClick = this.onCloseClick.bind(this);
	}

	onCloseClick(event) {
		delete localStorage.loggedUser;
		location.href = '#';
		event.preventDefault();
	}

	render() {
		
		if (!localStorage.loggedUser) { return null; }

		const user = JSON.parse(localStorage.loggedUser);

		const src = 'https://graph.facebook.com/' + user.id + '/picture';

		return (
			<div className="userFb table-responsive">

				<table className="table">
					<tbody>
						<tr>
							<td className="userFb-img"><img src={src} alt={user.name}  className="img-responsive img-circle" role="presentation"/></td>
							<td>
								<p className="userFb-name">{user.name}</p>
								<p><i className="fa fa-facebook"></i> <a href="" onClick={this.onCloseClick}>Salir</a></p>
								
							</td>
						</tr>						
					</tbody>
				</table>
				
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/UserFb.js